export const translations = {
  en: {
    // Header
    nav: {
      home: "Home",
      gaming: "Gaming",
      office: "Home & Office",
      support: "Support",
      about: "About",
      contact: "Contact"
    },
    
    // Homepage
    home: {
      heroTitle: "Work Smarter. Sit Better. Live Aligned",
      heroDesc: "Precision-designed / Human-centered ergonomic solutions that adapt to you, improving comfort and well-being throughout the day.",
      
      gamingTitle: "Gaming Accessories",
      gamingDesc: "RGB-enhanced setups engineered for competitive gaming",
      gamingCTA: "Explore Gaming",
      gamingLabel: "Performance & Style",
      
      officeTitle: "Home & Office",
      officeDesc: "Ergonomic solutions for productive, healthy workspaces",
      officeCTA: "Explore Home & Office",
      officeLabel: "Comfort & Wellness",
      
      whyChooseTitle: "",
      whyChooseDesc: "We don't just create products—we engineer experiences that elevate your workspace, whether you're gaming or working.",
      
      value1Title: "Premium Quality",
      value1Desc: "Every VIYERO product undergoes rigorous testing to ensure uncompromising standards.",
      
      value2Title: "Ergonomic Innovation",
      value2Desc: "Designed with your health and comfort in mind, backed by research and expertise.",
      
      value3Title: "Timeless Design",
      value3Desc: "Clean aesthetics that blend seamlessly into your space and age gracefully.",
      
      ctaTitle: "Ready to Transform Your Workspace?",
      ctaDesc: "Get in touch with us to learn more about our products and find the perfect solution for your needs.",
      ctaButton: "Contact Us"
    },
    
    // Gaming Page
    gaming: {
      heroTitle: "Engineered for",
      heroHighlight: "Victory",
      heroDesc: "Premium gaming hardware designed for competitive performance and immersive experiences. RGB-enhanced, battle-tested, victory-ready.",
      filterAll: "All",
      filterArms: "Monitor Arms",
      filterDesks: "Gaming Desks",
      filterAccessories: "Accessories",
      desksTitle: "Gaming Desks",
      desksDesc: "Choose from our premium gaming desk collection",
      featuresTitle: "Gaming-Grade Engineering",
      featuresDesc: "Every detail optimized for peak performance",
      feature1: "RGB Integration",
      feature1Desc: "Customizable lighting with 16.8M colors to match your setup perfectly.",
      feature2: "Precision Engineering",
      feature2Desc: "Gas-spring mechanisms and smooth adjustments for perfect positioning.",
      feature3: "Cable Management",
      feature3Desc: "Integrated solutions to keep your battlestation clean and organized."
    },
    
    // Office Page
    office: {
      heroTitle: "Designed for",
      heroHighlight: "Wellness",
      heroDesc: "Ergonomic solutions that promote health, comfort, and productivity in your home office, bedroom, or living space.",
      filterMonitorArms: "Monitor Arms",
      filterTvStands: "Mobile TV Stands",
      filterTvStandsFixed: "TV Stands",
      filterDysonStands: "Dyson Stands",
      filterAccessories: "Accessories",
      featuresTitle: "Ergonomic Excellence",
      featuresDesc: "Designed for your health and productivity",
      feature1: "Height Adjustable",
      feature1Desc: "Seamlessly switch between sitting and standing to promote better posture.",
      feature2: "Natural Materials",
      feature2Desc: "Premium wood finishes and sustainable materials for timeless aesthetics.",
      feature3: "Silent Operation",
      feature3Desc: "Quiet motors and smooth mechanisms that won't disturb your focus."
    },
    
    // Product Detail
    product: {
      backToGaming: "Back to Gaming Products",
      backToOffice: "Back to Office Products",
      keyFeatures: "Key Features",
      productFeatures: "Product Features",
      specifications: "Technical Specifications",
      contactButton: "Contact Us for Inquiries",
      gamingDesks: "Gaming Desks",
      relatedProducts: "Other Models"
    },
    
    // About Page
    about: {
      title: "About VIYERO",
      tagline: "Engineering Excellence in Every Detail",
      missionTitle: "Our Mission",
      mission: "At VIYERO, we believe that exceptional design and ergonomic innovation shouldn't be compromised. Whether you're conquering digital worlds or building your professional future, our products are engineered to elevate your experience.",
      valuesTitle: "What We Stand For",
      value1Title: "Premium Quality",
      value1Desc: "Every VIYERO product undergoes rigorous testing to ensure it meets our uncompromising standards.",
      value2Title: "Ergonomic Innovation",
      value2Desc: "We design with your health and comfort in mind, backed by ergonomic research and engineering expertise.",
      value3Title: "Timeless Design",
      value3Desc: "Our products blend seamlessly into your space with clean aesthetics that age gracefully.",
      productLinesTitle: "Our Product Lines",
      gamingTitle: "Gaming Hardware",
      gamingDesc: "High-performance setups engineered for competitive gaming with RGB integration and precision adjustments.",
      gamingMonitorArms: "Monitor Arms",
      gamingDesks: "Gaming Desks",
      gamingAccessories: "Accessories",
      officeTitle: "Office & Home",
      officeDesc: "Ergonomic solutions designed for wellness and productivity in home offices, bedrooms, and living spaces.",
      officeTvStands: "Mobile TV Stands",
      officeDesks: "Office Desks",
      officeAccessories: "Accessories"
    },
    
    // Contact Page
    contact: {
      title: "Get in Touch",
      subtitle: "Have questions about our products? Interested in becoming a distributor? We'd love to hear from you.",
      infoTitle: "Contact Information",
      email: "Email",
      address: "Address",
      addressValue: "VIYERO Headquarters, Istanbul",
      formTitle: "Send us a Message",
      name: "Name",
      namePlaceholder: "Your name",
      emailLabel: "Email",
      emailPlaceholder: "your.email@example.com",
      subject: "Subject",
      subjectPlaceholder: "What is this regarding?",
      message: "Message",
      messagePlaceholder: "Tell us more about your inquiry...",
      sendButton: "Send Message",
      sending: "Sending...",
      successMessage: "Message sent successfully! We'll get back to you soon."
    },
    
    // Footer
    footer: {
      description: "Engineering excellence in ergonomic design. From gaming setups to professional workspaces, we craft products that elevate your experience.",
      productsTitle: "Products",
      gamingHardware: "Gaming Hardware",
      officeHome: "Office & Home",
      companyTitle: "Company",
      about: "About Us",
      contact: "Contact",
      rights: "All rights reserved.",
      address: "VIYERO Headquarters, Istanbul"
    },
    
    // Support Page
    support: {
      heroTitle: "Product Support",
      heroDesc: "Download user manuals and installation guides for your VIYERO products",
      gamingDesksTitle: "Gaming Desks",
      gamingDesksDesc: "Support documentation for our gaming desk collection",
      userManual: "User Manual",
      installationManual: "Installation Manual",
      downloadPdf: "Download PDF",
      comingSoon: "Coming Soon"
    }
  },
  
  tr: {
    // Header
    nav: {
      home: "Ana Sayfa",
      gaming: "Oyun",
      office: "Ev & Ofis",
      support: "Destek",
      about: "Hakkımızda",
      contact: "İletişim"
    },
    
    // Homepage
    home: {
      heroTitle: "Verimli Çalışın... Rahat edin... Dengede Yaşayın...",
      heroDesc: "Size uyum sağlayan, gün boyu konforunuzu ve refahınızı artıran; hassasiyetle tasarlanmış, insan odaklı ergonomik çözümler.",
      
      gamingTitle: "Oyuncu Aksesuar ve Donanımları",
      gamingDesc: "Rekabetçi oyunlar için tasarlanmış, RGB destekli ürünler",
      gamingCTA: "Oyun Dünyası",
      gamingLabel: "Yüksek Performans ve Vurucu Stil",
      
      officeTitle: "Ev & Ofis",
      officeDesc: "Verimli ve ergonomik çalışma alanları için uygun çözümler",
      officeCTA: "Ev & Ofis Dünyası",
      officeLabel: "Konfor ve Ergonomi",
      
      whyChooseTitle: "",
      whyChooseDesc: "Sadece ürünler yaratmıyoruz; oyun oynarken ya da çalışırken, yaşam alanınızı üst seviyeye taşıyan deneyimler tasarlıyoruz.",
      
      value1Title: "Üstün Kalite",
      value1Desc: "Her VIYERO ürünü, taviz vermeyen standartları sağlamak için titiz testlerden geçer.",
      
      value2Title: "Ergonomik Tasarım",
      value2Desc: "Sağlığınız ve konforunuz düşünülerek, araştırma ve uzmanlıkla desteklenerek tasarlandı.",
      
      value3Title: "Zamansız Ürünler",
      value3Desc: "Alanınıza kusursuzca uyum sağlayan ve zarafetle yaşlanan temiz estetik.",
      
      ctaTitle: "Çalışma Alanınızı Dönüştürmeye Hazır mısınız?",
      ctaDesc: "Ürünlerimiz hakkında daha fazla bilgi edinmek ve ihtiyaçlarınıza uygun çözümü bulmak için bizimle iletişime geçin.",
      ctaButton: "İletişime Geçin"
    },
    
    // Gaming Page
    gaming: {
      heroTitle: "Zafer",
      heroHighlight: "İçin Tasarlandı",
      heroDesc: "Rekabetçi performans ve sürükleyici deneyimler için geliştirilmiş birinci sınıf oyun donanımları. RGB ile güçlendirildi, savaşta test edildi, zafere hazır.",
      filterAll: "Tümü",
      filterArms: "Monitör Kolları",
      filterDesks: "Oyun Masaları",
      filterAccessories: "Aksesuarlar",
      desksTitle: "Oyuncu Masaları",
      desksDesc: "Premium oyuncu masası koleksiyonumuzdan seçiminizi yapın.",
      featuresTitle: "Kazanmanıza Odaklı Mühendislik",
      featuresDesc: "Zirve performans için her detay optimize edildi.",
      feature1: "RGB Entegrasyonu",
      feature1Desc: "Sisteminize kusursuz uyum sağlaması için 16,8 milyon renge sahip özelleştirilebilir aydınlatma.",
      feature2: "Hassas Mühendislik",
      feature2Desc: "Mükemmel konumlandırma için amortisörlü (gazlı yay) mekanizmalar ve akıcı ayar imkanı.",
      feature3: "Kablo Yönetimi",
      feature3Desc: "Oyun istasyonunuzu temiz ve düzenli tutmak için entegre çözümler."
    },
    
    // Office Page
    office: {
      heroTitle: "Sağlık için",
      heroHighlight: "Tasarlandı",
      heroDesc: "Ev ofisinizde, yatak odanızda veya oturma alanınızda sağlığı, konforu ve üretkenliği destekleyen ergonomik çözümler.",
      filterMonitorArms: "Monitör Kolları",
      filterTvStands: "Mobil TV Standları",
      filterTvStandsFixed: "TV Standları",
      filterDysonStands: "Dyson Standları",
      filterAccessories: "Aksesuarlar",
      featuresTitle: "Ergonomik Mükemmellik",
      featuresDesc: "Sağlığınız ve üretkenliğiniz için tasarlandı",
      feature1: "Yükseklik Ayarlı",
      feature1Desc: "Daha iyi duruşu desteklemek için oturma ve ayakta durma arasında sorunsuzca geçiş yapın.",
      feature2: "Doğal Malzemeler",
      feature2Desc: "Zamansız estetik için premium ahşap kaplamalar ve sürdürülebilir malzemeler.",
      feature3: "Sessiz Çalışma",
      feature3Desc: "Odağınızı bozmayan sessiz motorlar ve pürüzsüz mekanizmalar."
    },
    
    // Product Detail
    product: {
      backToGaming: "Oyun Ürünlerine dön",
      backToOffice: "Ofis Ürünlerine Dön",
      keyFeatures: "Öne Çıkan Özellikler",
      productFeatures: "Ürün Özellikleri",
      specifications: "Teknik Özellikler",
      contactButton: "Bilgi ve İletişim için bize ulaşın",
      gamingDesks: "OYUNCU MASALARI",
      relatedProducts: "Diğer Modeller"
    },
    
    // About Page
    about: {
      title: "VIYERO: Her Alanda Üstün Performans",
      tagline: "",
      missionTitle: "Misyonumuz",
      mission: "VIYERO olarak misyonumuz; yenilikçi tasarımı teknolojiyle buluşturarak, evden ofise yaşamın her alanında estetik, fonksiyonel ve dayanıklı yaşam alanları yaratmaktır. Üstün mühendislik anlayışımızla, hem üretkenliği artıran hem de yaşam kalitesini zirveye taşıyan çözümler sunuyoruz.",
      valuesTitle: "Değerlerimiz",
      value1Title: "Üstün Kalite",
      value1Desc: "Her VIYERO ürünü, tavizsiz standartlarımızı karşıladığından emin olmak için zorlu testlerden geçer.",
      value2Title: "Ergonomik Tasarım",
      value2Desc: "Ergonomik araştırmalar ve mühendislik uzmanlığımızla, sağlığınızı ve konforunuzu ön planda tutarak tasarlıyoruz.",
      value3Title: "Zamansız Ürünler",
      value3Desc: "Ürünlerimiz, yıllara meydan okuyan yalın estetik anlayışıyla yaşam alanınıza kusursuz bir şekilde uyum sağlar.",
      productLinesTitle: "Ürün Gruplarımız",
      gamingTitle: "Oyuncu Donanımları",
      gamingDesc: "RGB entegrasyonu ve hassas ayar özellikleriyle, rekabetçi oyunlar için geliştirilmiş yüksek performanslı kurulumlar.",
      gamingMonitorArms: "Monitör Kolları",
      gamingDesks: "Oyuncu Masaları",
      gamingAccessories: "Aksesuarlar",
      officeTitle: "Ofis ve Ev",
      officeDesc: "Ev-ofisler, yatak odaları ve yaşam alanlarında sağlık ve verimlilik için tasarlanmış ergonomik çözümler.",
      officeTvStands: "Mobil TV Standları",
      officeDesks: "Ofis Masaları",
      officeAccessories: "Aksesuarlar"
    },
    
    // Contact Page
    contact: {
      title: "İletişime Geçin",
      subtitle: "Ürünlerimiz hakkında sorularınız mı var? Satıcı olmak ister misiniz? Sizden haber almak isteriz.",
      infoTitle: "İletişim Bilgileri",
      email: "E-posta",
      address: "Adres",
      addressValue: "VIYERO Merkez Ofis, Istanbul",
      formTitle: "Bize Mesaj Gönderin",
      name: "Ad, Soyad",
      namePlaceholder: "Adınız",
      emailLabel: "E-posta",
      emailPlaceholder: "email@ornek.com",
      subject: "Konu",
      subjectPlaceholder: "Hangi konuda?",
      message: "Mesaj",
      messagePlaceholder: "Taleplerinizi bekliyoruz...",
      sendButton: "Mesaj Gönder",
      sending: "Gönderiliyor...",
      successMessage: "Mesaj başarıyla gönderildi! En kısa sürede size dönüş yapacağız."
    },
    
    // Footer
    footer: {
      description: "Ergonomik tasarımda mühendislik ustalığı. Oyun tutkunuzdan profesyonel çalışma alanınıza kadar, her anınıza değer katan ve deneyiminizi güzelleştiren ürünler tasarlıyoruz.",
      productsTitle: "Ürünler",
      gamingHardware: "Oyun Donanımı",
      officeHome: "Ev & Ofis",
      companyTitle: "Şirket",
      about: "Hakkımızda",
      contact: "İletişim",
      rights: "Tüm hakları saklıdır.",
      address: "VIYERO Merkez Ofis, Istanbul"
    },
    
    // Support Page
    support: {
      heroTitle: "Ürün Desteği",
      heroDesc: "VIYERO ürünleriniz için kullanım kılavuzlarını ve kurulum yönergelerini indirin",
      gamingDesksTitle: "Oyun Masaları",
      gamingDesksDesc: "Oyun masası koleksiyonumuz için destek belgeleri",
      userManual: "Kullanım Kılavuzu",
      installationManual: "Kurulum Yönergeleri",
      downloadPdf: "PDF İndir",
      comingSoon: "Çok Yakında"
    }
  }
};
